import { TabRenderer } from './renderer/tab.renderer';

import { Component, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, WizCollectionUtils } from '@wizeoo/akm-core-lib';
import {
  WizDatasource,
  WizActionObj,
  WizRoot,
  WizTileList,
  BATCH_FILE_FORMAT,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { BaseView, ViewData, WizContextTabObj } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE, TabVO } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { filter, merge, Subscription } from 'rxjs';
import { CtxtEntry } from '@wizeoo/akm-common-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'newtab-view',
  templateUrl: './newtab.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewtabView extends BaseView {
  
  @ViewChild('customList') customList: WizTileList;
  
  public tabs: WizDatasource<WizActionObj> = new WizDatasource([])
  .setSelectionMode('multiple')
  .build(); // DS des tabs statiques

  public customTabs: WizDatasource<WizActionObj> = new WizDatasource<WizActionObj>([])
    .setItemCodeField('featureCode')
    .setSortFields([{property: 'viewOrder', way: 'asc', numeric: true}, {property: 'order', way: 'asc', numeric: true}, {property: 'label', way: 'asc', numeric: false}])
    .setSelectionMode('multiple')
    .build(); // DS des tabs dynamiques
  public renderer: any = TabRenderer; // rendu des thumbs

  private _sub$: Subscription;

  constructor(elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super(elementRef);
  }

  public wizAddListener(): void {
    super.wizAddListener();

    this._listenToTabSelections();
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.REMOVE_TAB, this.refreshCollections); // suppression d'un tab (affichage)
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.DELETE_TAB, this.deleteTab); // suppression d'un tab (en BDD)
    // écoute du retour d'import (batch pour refresh de la vue)
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport);
    // WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.VISION_CONTEXT_LOADED, this.updateFromVision); // modification de la portée vision au niveau de l'appli, rechargement
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION, this.updateFromVision); // modification de la portée vision au niveau de l'appli, rechargement

    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.customList, WIZ_EVENT_TYPE.DRAG_MOVED, this.moved);
  }



  private moved(e: WizEvent): void {
    
    let idx: number = 1;
    // 0 = source, 1 = target
    let fromTo: [TabVO, TabVO][] = [];
    

    this.customList.wizDataProvider.getSource().forEach(wao => {
      // console.log('moved', wao.buttonCode, wao.label, wao.viewOrder);
      
      let ft: [TabVO, TabVO] = [null, null];
      ft[0] = wao.data;
      let clone: TabVO = new TabVO(this.model, cloneDeep((wao.data as TabVO).source));
      clone.viewOrder = idx;
      ft[1] = clone;
      fromTo.push(ft);
      // console.log('ft',ft[0].viewOrder, ft[1].viewOrder);
      // console.log('wao',wao.buttonCode, wao.label, ft[0].viewOrder, ft[1].viewOrder);
      idx++;

    });

    Model.getInstance().tabEngine.mergeAll(fromTo, this.backFromTabOrder.bind(this));
  }

  private backFromTabOrder(tabs: TabVO[]): void {
    // console.log('backFromTabOrder', tabs);
    this.feed();
  }

  public wizRemoveListener(): void {
    super.wizRemoveListener();
    this._sub$.unsubscribe();
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.REMOVE_TAB); // suppression d'un tab
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.DELETE_TAB); // suppression d'un tab (en BDD)
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);
    // WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.VISION_CONTEXT_LOADED);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION);

    WizEventManager.removeListener(this, this.customList, WIZ_EVENT_TYPE.DRAG_MOVED);
  }

  public hasTab: boolean = true;
  public hasCustomTab: boolean = true;
  public dragEnabled = true;
  public contextMap: Map<string, WizContextTabObj>;

  wizSynchronizeData() {
    this.feed();
  }

  private updateFromVision(e: AlkEvent): void {
    // console.log('updateFromVision', e); 
    setTimeout(() => {
      this.feed();
    }, 200);
  }



  private feed() {
    let precursors: WizActionObj[] = Model.getInstance().tabEngine.availableTabs;
    // on tri direct
    precursors = WizCollectionUtils.doSort(precursors,[{property: 'viewOrder', way: 'asc', numeric: true}, {property: 'order', way: 'asc', numeric: true}, {property: 'label', way: 'asc', numeric: false}] );

    this.contextMap = new Map( Model.getInstance().tabEngine.userContextTabs.map((item) => [item.tabId, item]));
 
    this.tabs.setSource(
      precursors.filter(
        (wao: WizActionObj) => wao.kind === ViewData.KIND_STATIC && Model.getInstance().permissionEngine.canRead(wao.featureCode)
      )
    );
    this.customTabs.setSource(
      precursors.filter(
        (wao: WizActionObj) =>
          wao.kind === ViewData.KIND_DYNAMIC && Model.getInstance().permissionEngine.canRead(wao.featureCode)
      )
    );

    this.tabs.select(this.tabs.getWorkedSource().filter((wao: WizActionObj) => {
      // console.log('filter basics', wao.featureCode);
      if(this.contextMap.has(wao.featureCode)) {
        return true;
      }
      return false;
    }));

    this.customTabs.select(this.customTabs.getWorkedSource().filter((wao: WizActionObj) => {
      // console.log('filter custom', wao.featureCode);
      if(this.contextMap.has(wao.featureCode)) {
        return true;
      }
      return false;
    }));

    this.hasTab = this.tabs.getWorkedSource().length > 0;
    this.hasCustomTab = this.customTabs.getWorkedSource().length > 0;
    this.customTabs.refresh();

    this.cdref.markForCheck();
  }

  private refreshCollections(e: AlkEvent): void {
    this.wizSynchronizeData();
  }

  /**
   * ajout / suppression d'un tab à la pile
   */
  private _listenToTabSelections() {
    this._sub$ = merge(this.tabs.changes, this.customTabs.changes)
      .pipe(filter(({ type }) => type === 'selectionChanged'))
      .subscribe(({ action, item }) => {
        switch (action) {
          case 'added':
            let selection: WizActionObj[] = this.tabs.selectedItems;
            if (this.customTabs.selectedItems) {
              selection = selection.concat(this.customTabs.selectedItems);
            }

            const existArr: CtxtEntry[] = Model.getInstance().userContextService.getTabs();
            const existMap: Map<string, CtxtEntry> = new Map(existArr.map(item => [item.tabId, item]));
            selection.forEach((wao: WizActionObj) => {
              const meInMap: CtxtEntry = existMap.get(wao.featureCode);
              if (meInMap) {
                wao.order = meInMap.data?.order; // existArr.indexOf(meInMap);
              } else {
                wao.order = selection.length - 1;
              }
            });

            selection.sort((a, b) => a.order - b.order);
            // console.log('ut select', selection);
            Model.getInstance().tabEngine.updateContextTabs(selection);
            break;
          case 'deleted':
            Model.getInstance().tabEngine.removeTab(item as WizActionObj);
            break;
        }
      });
  }

  /** demande de suppression (bdd) d'un Tab */
  private deleteTab(e: AlkEvent): void {
    Model.getInstance().tabEngine.remove(e.data, this.backFromDelete.bind(this));
  }

  /** retour de suppression, suppression de la collection de tab */
  private backFromDelete(vo: TabVO, packStatus: string): void {
    const inst: WizActionObj = this.customTabs.getItemByKey(vo.featureCode);
    Model.getInstance().tabEngine.refreshTabs(); // va tout refresh
    this.refreshCollections(null);
  }

  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.TABS, BATCH_FILE_FORMAT.JSON, Model.getInstance().visionCode);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.TABS);
        break;
    }
  }

  /** callback sur retour d'import : recharger les Freedatas */
  private backFromImport(e: AlkEvent): void {
    // TODO recharger les tabs & features  & roles pour la vision uniquement...
    // TODO sur créa tab ajout rôle / refresh
  }

}
